import { ResourceOverridesInterface } from '@cbsinteractive/avia-js/dist/types/iface/ResourceOverridesInterface';

export class DefaultAviaConstants {
	private static _instance: DefaultAviaConstants = new DefaultAviaConstants();

	constructor() {
		if ( DefaultAviaConstants._instance ) {
			throw new Error(
				this.name +
				' is a Singleton and can only be accessed through ' +
				this.name +
				'.getInstance()'
			);
		}
		DefaultAviaConstants._instance = this;
	}

	public static getInstance(): DefaultAviaConstants {
		return DefaultAviaConstants._instance;
	}

	get name(): string {
		return 'DefaultAviaConstants';
	}

	/**
	 * @description Returns default overrides for ResourceConfiguration
	 * @return {ResourceOverridesInterface}
	 */
	get overrides(): ResourceOverridesInterface {
		return {
			// decrease minimum DVR duration (default 1800 seconds) to enable seek bar earlier
			minDvrDuration: 600
		} as ResourceOverridesInterface;
	}

	/**
	 * @description Start bitrate. Returns average low value between VOD and Live to speed up video start
	 * @return {number}
	 */
	get startBitrate(): number {
		return 250000;
	}

	/**
	 * @description Returns start bitrate value forcing SD resolution (this can be calculated where needed to i.e. cap bitrate / resolution per business rules)
	 * @return {number}
	 */
	get maxBitrate(): number {
		return NaN;
	}
}